export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;
export const SENTRY_AUTH_TOKEN = import.meta.env.VITE_SENTRY_AUTH_TOKEN as string;
export const SENTRY_ORG = import.meta.env.VITE_SENTRY_ORG as string;
export const SENTRY_PROJECT = import.meta.env.VITE_SENTRY_PROJECT as string;
